import { ComponentType } from 'react';
import { lazy } from 'react';

interface RouteConfig {
  path: string;
  component: ComponentType<any>;
  protected: boolean;
}

export const routes: RouteConfig[] = [
  {
    path: '/*',
    component: lazy(() =>
      import('@pages/Dashboard').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },

  {
    path: '/orders',
    component: lazy(() =>
      import('@pages/Orders/Orders').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },
  {
    path: '/orders/addOrders',
    component: lazy(() =>
      import('@pages/Orders/AddOrders').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },

  {
    path: 'orders/ordertransactions',
    component: lazy(() =>
      import('@pages/Orders/OrderTransactions').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },

  {
    path: '/foodmenu',
    component: lazy(() =>
      import('@/masters/FoodMenu/FoodMenu').then((module) => ({
        default: module.default,
      })),
    ),
    protected: true,
  },
  {
    path: '/foodmenu/addfoodmenu',
    component: lazy(() =>
      import('@masters/FoodMenu/AddFoodMenu').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },
  // {
  //   path: '/inventory',
  //   component: lazy(() =>
  //     import('@/masters/FoodMenu/Inventory').then((module) => ({ default: module.default })),
  //   ),
  //   protected: true,
  // },

  // COOK
  {
    path: '/cooks',
    component: lazy(() =>
      import('@pages/Cook/Cook').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },
  {
    path: '/cooks/addcooks',
    component: lazy(() =>
      import('@pages/Cook/AddCook').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },
  {
    path: '/cooks/cookdetails',
    component: lazy(() =>
      import('@pages/Cook/CookDetails').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },
  {
    path: '/weeklyCooksFeed',
    component: lazy(() =>
      import('@/pages/Cook/WeeklyCooksFeed').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },

  // {
  //   path: '/addfood',
  //   component: lazy(() =>
  //     import('@pages/Cook/AddFood').then((module) => ({ default: module.default })),
  //   ),
  //   protected: true,
  // },
  {
    path: '/foodListing',
    component: lazy(() =>
      import('@/pages/Cook/CooksFoodListings').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },

  {
    path: '/foodApproval',
    component: lazy(() =>
      import('@pages/Cook/FoodApprovalRequests').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },

  {
    path: '/customers',
    component: lazy(() =>
      import('@pages/Customers/Customer').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },
  {
    path: '/customers/addcustomer',
    component: lazy(() =>
      import('@pages/Customers/AddCustomer').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },
  {
    path: '/diettype',
    component: lazy(() =>
      import('@/masters/DietType/DietType').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },
  {
    path: '/allergence',
    component: lazy(() =>
      import('@masters/allergence/Allergence').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },
  {
    path: '/city',
    component: lazy(() =>
      import('@/masters/City/City').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },
  {
    path: '/areacode',
    component: lazy(() =>
      import('@masters/AreaCode/AreaCode').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },
  {
    path: '/Cuisinetype',
    component: lazy(() =>
      import('@masters/cuisineType/CuisineType').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },
  {
    path: '/packunit',
    component: lazy(() =>
      import('@masters/packUnits/PackUnits').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },
  {
    path: '/foodCategory',
    component: lazy(() =>
      import('@masters/foodCategory/FoodCategory').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },
  {
    path: '/finance',
    component: lazy(() =>
      import('@pages/Finance/Finance').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },

  {
    path: '/areamanager',
    component: lazy(() =>
      import('@pages/AreaManager/AreaManager').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },
  {
    path: '/areamanager/addareamanager',
    component: lazy(() =>
      import('@pages/AreaManager/AddAreaManager').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },
  {
    path: '/ingredients',
    component: lazy(() =>
      import('@masters/Ingredients/Ingredients').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },
  {
    path: '/mealtype',
    component: lazy(() =>
      import('@masters/Meal Type/MealType').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },
  {
    path: '/kycdocumenttype',
    component: lazy(() =>
      import('@masters/KycDocumentType/KycDocumentType').then((module) => ({
        default: module.default,
      })),
    ),
    protected: true,
  },
  {
    path: '/analytics',
    component: lazy(() =>
      import('@pages/Analytics/Analytics').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },
  {
    path: '/spice',
    component: lazy(() =>
      import('@masters/spice/Spice').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },
  {
    path: '/cooks/postmeal',
    component: lazy(() =>
      import('@pages/Cook/PostMeal').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },
  {
    path: '/cooks/postmeal/foodPost',
    component: lazy(() =>
      import('@pages/Cook/FoodPost').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },

  {
    path: '/foodApproval',
    component: lazy(() =>
      import('@pages/Cook/FoodApprovalRequests').then((module) => ({ default: module.default })),
    ),
    protected: true,
  },
  {
    path: '/cooks/addfoodmenuitem',
    component: lazy(() =>
      import('@pages/Cook/FoodMenuItem/AddFoodMenuItem').then((module) => ({
        default: module.default,
      })),
    ),
    protected: true,
  },
  {
    path: '/cooks/addfoodmenuitem/ingredientmanagement',
    component: lazy(() =>
      import('@pages/Cook/FoodMenuItem/IngredientsManagement').then((module) => ({
        default: module.default,
      })),
    ),
    protected: true,
  },
  {
    path: '/secondarydiettype',
    component: lazy(() =>
      import('@masters/secondaryDietType/SecondaryDietType').then((module) => ({
        default: module.default,
      })),
    ),
    protected: true,
  },
  {
    path: '/areamanagerdeliveries',
    component: lazy(() =>
      import('@pages/AreaManager/AreaManagerDeliveries').then((module) => ({
        default: module.default,
      })),
    ),
    protected: true,
  },
  {
    path: '/idam',
    component: lazy(
      () => import('@/pages/Idam/IdamAdminIndex').then((m) => ({ default: m.default })),
      // OR: import('@idam/IdamAdminIndex').then(m => ({ default: m.default })),
    ),
    protected: true,
  },
  // ================== IDAM ==================

  // Roles
  {
    path: '/idam/roles',
    component: lazy(
      () =>
        // if you created at src/pages/masters/Roles.tsx
        import('@/pages/Idam/masters/Roles').then((m) => ({ default: m.default })),
      // OR: import('@idam/Roles').then(m => ({ default: m.default })),
    ),
    protected: true,
  },

  // Permissions
  {
    path: '/idam/permissions',
    component: lazy(
      () => import('@/pages/Idam/masters/Permissions').then((m) => ({ default: m.default })),
      // OR: import('@idam/Permissions').then(m => ({ default: m.default })),
    ),
    protected: true,
  },

  // Menus
  {
    path: '/idam/menus',
    component: lazy(
      () => import('@/pages/Idam/masters/Menus').then((m) => ({ default: m.default })),
      // OR: import('@masters/Menus').then(m => ({ default: m.default })),
    ),
    protected: true,
  },

  // User Status
  {
    path: '/idam/user-status',
    component: lazy(
      () => import('@/pages/Idam/masters/UserStatus').then((m) => ({ default: m.default })),
      // OR: import('@masters/UserStatus').then(m => ({ default: m.default })),
    ),
    protected: true,
  },

  // OTP Types
  {
    path: '/idam/otp-types',
    component: lazy(
      () => import('@/pages/Idam/masters/OtpTypes').then((m) => ({ default: m.default })),
      // OR: import('@masters/OtpTypes').then(m => ({ default: m.default })),
    ),
    protected: true,
  },

  // ================== Mappings ==================

  // Role ↔ Permission
  {
    path: '/idam/role-permission',
    component: lazy(
      () => import('@/pages/Idam/mappings/RolePermission').then((m) => ({ default: m.default })),
      // OR: import('@idam/RolePermission').then(m => ({ default: m.default })),
    ),
    protected: true,
  },

  // User ↔ Role
  {
    path: '/idam/user-role',
    component: lazy(
      () => import('@/pages/Idam/mappings/UserRole').then((m) => ({ default: m.default })),
      // OR: import('@idam/UserRole').then(m => ({ default: m.default })),
    ),
    protected: true,
  },
  {
    path: '/idam/users',
    component: lazy(() => import('@/pages/Idam/users/Users').then((m) => ({ default: m.default }))),
    protected: true,
  },
  {
    path: '/idam/adduser',
    component: lazy(() =>
      import('@/pages/Idam/users/AddUser').then((m) => ({ default: m.default })),
    ),
    protected: true,
  },
  {
    path: '/idam/reports/sessions',
    component: lazy(() =>
      import('@/pages/Idam/Reports/UserSessions').then((m) => ({ default: m.default })),
    ),
    protected: true,
  },
  {
    path: '/idam/reports/devices',
    component: lazy(() =>
      import('@/pages/Idam/Reports/UserDevices').then((m) => ({ default: m.default })),
    ),
    protected: true,
  },
  {
    path: '/idam/reports/otp-requests',
    component: lazy(() =>
      import('@/pages/Idam/Reports/OtpRequests').then((m) => ({ default: m.default })),
    ),
    protected: true,
  },
  {
    path: '/idam/reports/signins',
    component: lazy(() =>
      import('@/pages/Idam/Reports/Signins').then((m) => ({ default: m.default })),
    ),
    protected: true,
  }, // wherever you register routes
  {
    path: '/idam/masters/signin-status',
    component: lazy(() =>
      import('@/pages/Idam/masters/SigninStatus').then((m) => ({ default: m.default })),
    ),
    protected: true,
  },
  {
    path: '/idam/masters/signin-methods',
    component: lazy(() =>
      import('@/pages/Idam/masters/SigninMethod').then((m) => ({ default: m.default })),
    ),
    protected: true,
  },
  {
    path: '/idam/masters/otp-identifier-types',
    component: lazy(() =>
      import('@/pages/Idam/masters/OtpIdentifierTypes').then((m) => ({ default: m.default })),
    ),
    protected: true,
  },
  {
    path: '/idam/masters/otp-purposes',
    component: lazy(() =>
      import('@/pages/Idam/masters/OtpPurposes').then((m) => ({ default: m.default })),
    ),
    protected: true,
  },
  {
    path: '/kycapprovals',
    component: lazy(() =>
      import('@pages/KycApprovals/kycApprovals').then((m) => ({ default: m.default })),
    ),
    protected: true,
  },
  {
    path: '/cooks/foodscheduleorders',
    component: lazy(() =>
      import('@pages/Cook/FoodScheduleOrders').then((m) => ({ default: m.default })),
    ),
    protected: true,
  },
  {
    path: '/applicationsettings',
    component: lazy(() =>
      import('@/masters/ApplicationSettings/ApplicationSettings').then((m) => ({
        default: m.default,
      })),
    ),
    protected: true,
  },
  {
    path: '/weeklyschedulefoods',
    component: lazy(() =>
      import('@pages/Orders/WeeklyScheduleFoods').then((m) => ({
        default: m.default,
      })),
    ),
    protected: true,
  },
  {
    path: '/deliveryareadiscounts',
    component: lazy(() =>
      import('@masters/Discounts/deliveryAreaDiscounts').then((m) => ({
        default: m.default,
      })),
    ),
    protected: true,
  },

  {
    path: '/deliverycharges',
    component: lazy(() =>
      import('@masters/Discounts/deliveryCharges').then((m) => ({
        default: m.default,
      })),
    ),
    protected: true,
  },
  {
    path: '/cookmenuapprovals',
    component: lazy(() =>
      import('@pages/Cook/CookMenuApprovals/CookMenuApprovals').then((m) => ({
        default: m.default,
      })),
    ),
    protected: true,
  },
  {
    path: '/paymentsuccess',
    component: lazy(() =>
      import('@pages/Payments/PaymentSuccessScreen').then((m) => ({
        default: m.default,
      })),
    ),
    protected: true,
  },
  {
    path: '/paymentfailure',
    component: lazy(() =>
      import('@pages/Payments/PaymentFailureScreen').then((m) => ({
        default: m.default,
      })),
    ),
    protected: true,
  },
  {
    path: '/promotions',
    component: lazy(() =>
      import('@pages/Promotions/Promotions').then((m) => ({
        default: m.default,
      })),
    ),
    protected: true,
  },
  {
    path: '/payouts',
    component: lazy(() =>
      import('@pages/Payouts/Payout').then((m) => ({
        default: m.default,
      })),
    ),
    protected: true,
  },
  {
    path: '/payouts/checkpayout',
    component: lazy(() =>
      import('@pages/Payouts/CheckPayout').then((m) => ({
        default: m.default,
      })),
    ),
    protected: true,
  },
  {
    path: '/discountcoupons',
    component: lazy(() =>
      import('@pages/Discounts/DiscountCoupons').then((m) => ({
        default: m.default,
      })),
    ),
    protected: true,
  },
  {
    path: '/termsconditions',
    component: lazy(() =>
      import('@pages/TermsAndConditions/TermsAndConditions').then((m) => ({
        default: m.default,
      })),
    ),
    protected: true,
  },
  {
    path: '/conveniencefees',
    component: lazy(() =>
      import('@pages/ConvenienceFee/ConvenienceFee').then((m) => ({
        default: m.default,
      })),
    ),
    protected: true,
  },
  {
    path: '/menupoll',
    component: lazy(() =>
      import('@pages/MenuPoll/MenuPoll').then((m) => ({
        default: m.default,
      })),
    ),
    protected: true,
  },
  {
    path: '/menupoll/analytics',
    component: lazy(() =>
      import('@pages/MenuPoll/MenuPollAdminAnalytics').then((m) => ({
        default: m.default,
      })),
    ),
    protected: true,
  },
  {
    path: '/versionmanagement',
    component: lazy(() =>
      import('@masters/VersionManagement/VersionManagement').then((m) => ({
        default: m.default,
      })),
    ),
    protected: true,
  },
  {
    path: '/videos',
    component: lazy(() =>
      import('@pages/videos/videos').then((m) => ({
        default: m.default,
      })),
    ),
    protected: true,
  },
];
